import * as overview from '../actions/overview.actions';
import { OverviewState } from '../overview.state';

const initialState: OverviewState = {
    searchFilterSort: {
        search: null,
        sortBy: {
            type: null,
            order: null
        },
        params: null,
    },
    totalItems: 0,
    loading: true
};

export const overviewReducer = (state: OverviewState = initialState,
                                action) => {
    switch (action.type) {
        case overview.ActionTypes.ADD_OVERVIEW_CONTENT:
            return {...state, searchFilterSort: action.payload};
        case overview.ActionTypes.SET_TOTAL_ITEMS:
            return {...state, totalItems: action.payload};
        case overview.ActionTypes.SET_LOADING:
            return {...state, loading: action.payload};
        default:
            return state;
    }
};
